module.exports = __webpack_public_path__ + "static/media/Telus_One_page-20.44134f01.png";